module.exports = __webpack_public_path__ + "static/media/druggist.02a0f376.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/PersonalInfo/images/druggist.png
// module id = 241
// module chunks = 0